import React, { useState, useEffect } from 'react';
import UploadImgProyecto from '../EditProyecto.jsx/ConfigProyecto/UploadImgProyecto';
import ModalImageSelectedCreate from './ModalImageSelectedCreate';

const CreateImageProyecto = ({ onImageSelect, existingImage }) => {
  const [previewImage, setPreviewImage] = useState(null);
  const [uploadedImage, setUploadedImage] = useState(existingImage || null);

  useEffect(() => {
    if (existingImage) {
      setUploadedImage(existingImage);
    }
  }, [existingImage]);

  const handleOnClosePreview = () => {
    setPreviewImage(null);
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    event.target.value = null;

    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleImageConfirm = (image) => {
    onImageSelect(image);
    setUploadedImage(image);
    setPreviewImage(null); 
  };

  return (
    <div className="container-upload-image" style={{ width: '100%', height: '100%', position: 'relative' }}>
      {previewImage && (
        <ModalImageSelectedCreate
          preview={previewImage}
          handleOnClose={handleOnClosePreview}
          onConfirm={handleImageConfirm}
        />
      )}
      <div className="image-project-container" style={{ width: '100%', height: '100%', position: 'relative' }}>
        {uploadedImage ? (
          <>
            <img 
              src={uploadedImage} 
              alt="Imagen subida" 
              className="image-project" 
             
            />
            <div className="upload-image-hover" >
              <UploadImgProyecto handleImageChange={handleImageChange} />
            </div>
          </>
        ) : (
          <UploadImgProyecto handleImageChange={handleImageChange} />
        )}
      </div>
    </div>
  );
};

export default CreateImageProyecto;